import { Sparkles, X } from "lucide-react";

const LABEL = { photo: "New photo added", voice: "New voice note", text: "Notes changed" };

/* Inline, dismissible prompt to re-run extraction with everything captured so far. */
export const UpdateCardBanner = ({ pending, hasCard, onUpdate, onDismiss }) => {
  const msg = !hasCard ? "Write job card from photos?" : pending.length === 1 ? `${LABEL[pending[0]]} — update job card?` : "Inputs changed — update job card?";
  return (
    <div className="card mt-4 flex items-center gap-3 fade-up update-banner" role="status" data-testid="update-card-banner" data-reason={hasCard ? pending.join("+") : "photos-only"}>
      <Sparkles size={16} className="text-primary shrink-0" />
      <p className="text-sm flex-1">{msg}</p>
      <button type="button" className="btn-primary !w-auto !py-1.5 !px-3 text-sm" onClick={onUpdate} data-testid="update-card-button">{hasCard ? "Update job card" : "Write job card"}</button>
      {hasCard && <button type="button" className="icon-btn !w-8 !h-8" onClick={onDismiss} aria-label="Dismiss" data-testid="update-card-dismiss"><X size={14} /></button>}
    </div>
  );
};
